import { RecursiveLinkInterface } from '../components/menu/menu.model';
import { ProgramType, WebinarType } from '../enum/webinar-course.enum';
import { SideMenuItem } from '../models/ui.model';

export enum MenuType {
    Courses,
    Webinars,
    WebinarsType,
    Topic,
    EInvoicing,
    UpdateClasses,
    IncomeTax,
    Forms,
    SST,
    Resources,
    MyLearning,
    AskAnExpert,
    Deals,
    FAQ,
    Podcast,
    TaxTopics,
    WebinarsGroup,
    Community,
    TaxExplorer,
}

export const MAIN_MENU_ITEMS: RecursiveLinkInterface[] = [
    {
        label: 'menu.webinars',
        menuType: MenuType.Webinars,
        link: '/program/list/webinar',
        param: { programType: ProgramType.Webinar },
        htmlId: 'webinarNav',
        isColumnLayout: true,
        children: [
            {
                // Column header. Links to the same browse-all listing as the top-level
                // "Webinars" trigger. That is deliberate duplication: every other column
                // heading is a link, so leaving this one as plain text made it the only
                // dead word in the panel - it drag-selected instead of clicking.
                label: 'menu.webinars',
                menuType: MenuType.WebinarsGroup,
                link: '/program/list/webinar',
                param: { programType: ProgramType.Webinar },
                children: [
                    {
                        label: 'menu.liveWebinars',
                        menuType: MenuType.WebinarsType,
                        link: '/program/list/webinar',
                        param: { webinarType: WebinarType.Live },
                    },
                    {
                        label: 'menu.recordedWebinars',
                        menuType: MenuType.WebinarsType,
                        link: '/program/list/webinar',
                        param: { webinarType: WebinarType.Recorded },
                    },
                ],
            },
            {
                // Was top-level before TPOD-3318; keeps its link so the entry point
                // survives. assignTopicsToMenu() fills link/param/children at runtime.
                label: 'menu.updateClasses',
                menuType: MenuType.UpdateClasses,
                link: '',
            },
        ],
    },
    {
        label: 'menu.taxTopics',
        menuType: MenuType.TaxTopics,
        htmlId: 'taxTopicsNav',
        isColumnLayout: true,
        children: [
            { label: 'menu.eInvoicing', menuType: MenuType.EInvoicing, link: '' },
            { label: 'menu.incomeTax', menuType: MenuType.IncomeTax, link: '' },
            { label: 'menu.forms', menuType: MenuType.Forms, link: '' },
            { label: 'menu.sst', menuType: MenuType.SST, link: '' },
        ],
    },
    {
        label: 'menu.resources',
        menuType: MenuType.Resources,
        htmlId: 'resourceNav',
        children: [
            { label: 'menu.accountingTrainingHoursCPE', link: '/resource/about-cpe', cssClass: 'long-text' },
            { label: 'menu.articles', link: '/resource/article' },
            { label: 'menu.ourSpeakers', link: '/resource/speaker' },
            { label: 'menu.quickGuides', link: '/resource/quick-guide' },
            { label: 'menu.taxAMinute', link: '/resource/tax-a-minute' },
            { label: 'menu.faq', menuType: MenuType.FAQ, link: '/faq' },
            { label: 'menu.podcast', menuType: MenuType.Podcast, link: '/program/list/podcast', param: { programType: ProgramType.Podcast } },
            { label: 'menu.deals', menuType: MenuType.Deals, link: '/deals', htmlId: 'dealsNav' },
        ],
    },
    {
        label: 'menu.askAnExpert',
        menuType: MenuType.AskAnExpert,
        link: '/ask-an-expert',
        cssClass: 'ask-expert',
        htmlId: 'askAnExpertNav',
        icon: 'bg-ask-expert-icon ask-expert',
    },
    {
        label: 'menu.taxExplorer',
        menuType: MenuType.TaxExplorer,
        link: '/tax-explorer',
        htmlId: 'taxExplorerNav',
    },
];

/**
 * Not in MAIN_MENU_ITEMS on purpose: the navbar adds it (after Ask an Expert) only once the Community flag lets the member in, so any
 * failure or early exit while the menu is built leaves it out rather than showing a feature the member may not have.
 */
export const COMMUNITY_MENU_ITEM: RecursiveLinkInterface = {
    label: 'menu.community',
    menuType: MenuType.Community,
    link: '/community',
    htmlId: 'communityNav',
};

export const SIDE_MENU_ITEMS: SideMenuItem[] = [
    {
        link: '/user/profile',
        title: 'menu.profile',
        icon: 'user-profile',
    },
    {
        link: '/user/my-preferences',
        title: 'menu.myPreferences',
        icon: 'my-preferences',
    },
    {
        link: '/user/favourite',
        title: 'menu.myFavorites',
        icon: 'heart',
    },
    {
        link: '/user/subscription-billing',
        title: 'menu.subscriptionAndBilling',
        icon: 'my-subscription-billing',
    },
    {
        link: '/user/training-cpe-hours',
        title: 'pageTitle.myTrainingCPEHours',
        icon: 'my-training-cpe-hours',
    },
    {
        link: '/user/courses-and-webinars',
        title: 'pageTitle.myCoursesAndWebinars',
        icon: 'my-programs',
        id: 'myLearningNav',
    },
    {
        link: '/user/settings',
        title: 'menu.settings',
        icon: 'settings',
    },
];

export const STATUS_TOPIC = {
    updateClasses: 'Update Classes',
    eInvoicing: 'E-Invoicing',
    incomeTax: 'Income Tax',
    forms: 'Forms',
    sst: 'SST',
};
